import type { NodeEntry } from "slate";
import {
  Editor,
  Element,
  Node,
  Path,
  Range,
  select,
  Text,
  Transforms,
} from "slate";
import { HistoryEditor } from "slate-history";

import { Helpers } from "../helpers";
import { NodeTypes } from "../slateTypes";

export const withCustomBrake = (editor: any) => {
  const { insertBreak, insertSoftBreak, insertText, normalizeNode } = editor;

  const needNormalize: NodeTypes[] = [NodeTypes.HEADING];

  editor.normalizeNode = (entry: NodeEntry) => {
    const [node, path] = entry;
    if (
      Element.isElement(node) &&
      node.type === NodeTypes.LINK &&
      node.children[0].text === ""
    ) {
      HistoryEditor.withoutSaving(editor, () => {
        Transforms.removeNodes(editor, { at: path });
      });
      return;
    }

    if (Element.isElement(node) && node.type === NodeTypes.CODE_LINE) {
      for (const [child, childPath] of Node.children(editor, path)) {
        if (Element.isElement(child)) {
          Transforms.unwrapNodes(editor, { at: childPath });
        }
        if (Text.isText(child) && Object.keys(child).length > 1) {
          Transforms.unsetNodes(editor, "emphasis", { at: childPath });
          Transforms.unsetNodes(editor, "strong", { at: childPath });
        }
      }
      return;
    }
    if (Element.isElement(node) && node.type === NodeTypes.BLOCK_QUOTE) {
      for (const [child, childPath] of Node.children(editor, path)) {
        if (
          Element.isElement(child) &&
          needNormalize.includes(child.type as NodeTypes)
        ) {
          Transforms.unwrapNodes(editor, { at: childPath });
          Transforms.wrapNodes(
            editor,
            { type: NodeTypes.PARAGRAPH, children: [] },
            { at: childPath },
          );
        }
      }
      return;
    }
    normalizeNode(entry);
  };

  editor.insertSoftBreak = () => {
    if (Helpers.isElement(editor, NodeTypes.BLOCK_CODE)) {
      Helpers.insertParagraph(editor, NodeTypes.BLOCK_CODE);
      return;
    }

    if (
      Helpers.isElement(editor, NodeTypes.BLOCK_QUOTE) ||
      Helpers.isElement(editor, NodeTypes.PARAGRAPH) ||
      Helpers.isElement(editor, NodeTypes.LIST_ITEM_TEXT)
    ) {
      insertText("\n");
      return;
    }
    insertSoftBreak();
  };

  editor.insertBreak = () => {
    if (Helpers.isElement(editor, NodeTypes.BLOCK_QUOTE)) {
      Helpers.insertParagraph(editor, NodeTypes.BLOCK_QUOTE);
      return;
    }
    if (Helpers.isElement(editor, NodeTypes.BLOCK_CODE)) {
      insertText("\n");
      return;
    }
    insertBreak();
  };

  return editor;
};
